<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.practitioners', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ fullName }}
                        </h3>
                    </div>


                                    <div class="card-title">
                                        <b-button class="mb-2 ml-4 btn btn-sm" variant="primary" @click="toAddInstitution">
                                            {{ $t('message.add') }} {{ $tc('message.institutions', 1) }}
                                        </b-button>
                                    </div>


                    <b-container>
                        <div class="list-group-flush">
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.lastName') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.nom) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.firstName') }}:

                                            <span class="font-weight-bold">
                                                {{ mPractitionerUserInformation.prenom != null ? getValue(mPractitionerUserInformation.prenom) : " "}}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.email') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.email) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.phoneNumber') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.telephone) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.civility') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitioner.civilite) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.orderNumber') }}:

                                            <span class="font-weight-bold">
                                                {{(getValue(mPractitioner.numero_ordre) == "null" || getValue(mPractitioner.numero_ordre) == null) ? '0000' :getValue(mPractitioner.numero_ordre)  }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6">
                                    <div>
                                    <div class="list-group-item">
                                        {{ $t('message.nationality') }}:

                                        <span class="font-weight-bold">
                                            {{ getValue(mPractitionerUserInformation.nationalite) }}
                                        </span>
                                    </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $tc('message.countries', 1) }}:

                                            <span class="font-weight-bold">
                                                {{ mPractitionerUserInformation.pays }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $tc('message.cities', 1) }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.ville) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.street') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.quartier) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.zipCode') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.code_postal) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $tc('message.address') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mPractitionerUserInformation.adresse) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <b-row>
                                <b-col class="align-items-center" col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.signature') }}:

                                        <span class="font-weight-bold">
                                            <img :src="image" class="card-img-top" alt="Image does not show">
                                        </span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>


<!--                    <div class="card-body p-1em">-->
<!--                        <h3 class="card-title text-center mb-0">-->
<!--                            {{ $tc('message.institutions', 2) }}-->
<!--                        </h3>-->
<!--                    </div>-->

<!--                    <ol>-->
<!--                        <li v-for="institution in mPractitioner.etablissements" :key="institution.id">-->
<!--                            <span class="font-weight-bold">-->
<!--                                {{ institution.name }}-->
<!--                            </span>-->
<!--                        </li>-->
<!--                    </ol>-->
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can || hasAssistante">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updatePractitioner">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>

                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <hr>
                                <h3 class="text-center">{{ $tc('message.institutions', 2) }}</h3>
                                <vue-good-table
                                        id="allergie"
                                        v-if="pInstitutions"
                                        :columns="pInstitutionsColumns"
                                        :rows="pInstitutions"
                                        :search-options="enabled"
                                        :pagination-options="paginationOptions"
                                        :select-options="{
                                            enabled: true,
                                          }"
                                        ref="institution-table"
                                >
                                    <div slot="selected-row-actions" v-if="hasGestionnaireRole || hasAdminRole">
                                        <button @click="removeEtablissement">Supprimer</button>
                                    </div>
                                </vue-good-table>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.practitioners', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mPractitioner.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deletePractitioner">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import AppConfig from '../../constants/AppConfig';


    export default {
        name: "Practitioner",

        computed: {
            ...mapGetters(["practitioner",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mPractitioner: function() {
                return this.practitioner;
            },

            mPractitionerUserInformation:function(){
                if (typeof this.mPractitioner.user == 'object'){
                    return this.mPractitioner.user;
                }
                return {};
            },

            pInstitutions:function(){
                return this.mPractitioner.etablissements;
            },

            fullName:function () {
                let prenom  = this.mPractitionerUserInformation.prenom != null ? this.mPractitionerUserInformation.prenom : "";
                prenom =  prenom.toLowerCase();
                return (this.getValue(this.mPractitionerUserInformation.nom)).toUpperCase() + " "+prenom.charAt(0).toUpperCase() + prenom.substring(1);
            },

            image: function() {
                return AppConfig.imgUrl + '/public/storage/' + this.mPractitioner.signature;
            }
        },

        data() {
            return {
                practitioner_id: this.$route.params.practitioner,

                pInstitutionsColumns:[
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'name',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                    },
                ],

                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},
            }
        },

        methods: {
            removeEtablissement() {
                let etablissementId=[];
                _.forEach(this.$refs['institution-table'].selectedRows,function (row) {
                    etablissementId.push(row.id)

                });
                let args = {
                    praticien_id: this.practitioner.user_id,
                    etablissement_id:etablissementId
                };

                let successMessage = this.$i18n.t('message.institutionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('removePraticienInstitution', { args, successMessage, errorMessages });
            },

            toAddInstitution() {
                this.$router.push({ name: 'add-praticien-institution', params: { praticien: this.practitioner_id } })
            },

            getPractitioner() {
                let args = {
                    practitioner: this.practitioner_id
                };

                this.$store.dispatch("getPractitioner", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updatePractitioner() {
                this.$router.push({ name: 'edit-practitioner', params: { practitioner: this.practitioner_id } });
            },

            deletePractitioner() {
                let self = this;
                let args = {
                    practitioner: this.practitioner_id
                };

                let successMessage = this.$i18n.t('message.practitionerDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePractitioner', { args, index: self.practitioner_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },
            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
        },
        mounted() {
            this.getPractitioner();
        }
    }
</script>

<style scoped>

</style>